import {
    Component, OnInit, Input, forwardRef, SimpleChange, OnChanges, Output, EventEmitter
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS, FormControl } from '@angular/forms';

import { LocaleConfig } from './timepicker.config';

import _moment from 'proxies/dayjs';
import { AppService } from '../../shared/services/app.service';
import { UtilService } from '../../services/util.service';
import { ValidationService } from '../form/validation.service';
const moment = _moment;


@Component({
    selector: 'dhs-timepicker',
    styleUrls: ['./timepicker.component.scss'],
    templateUrl: './timepicker.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimePickerComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => TimePickerComponent), multi: true
        }],
    standalone: false
})
export class TimePickerComponent implements ControlValueAccessor, OnChanges, OnInit {
    //added for validation
    @Input('validations') _validations: any;
    @Input('value') _value: any;

    @Input()
    minDate: any = null;
    @Input()
    maxDate: any = null;

    @Input()
    minDateNumber: number;
    @Input()
    minDateUnit: any;

    @Input()
    maxDateNumber: number;
    @Input()
    maxDateUnit: any;
    @Input() disabled: boolean = false;
    timepickerVariables: any = {};
    @Input()
    startDate: any = moment();

    // timepicker variables
    @Input()
    timePicker: Boolean = true;
    @Input()
    timePicker24Hour: Boolean = false;
    @Input()
    timePickerIncrement = 1;
    @Input()
    timePickerSeconds: Boolean = false;
    // end of timepicker variables

    _locale: LocaleConfig = {};
    // @Input() set locale(value) {
    //     this._locale = { ...this._localeService.config, ...value };
    // }
    get locale(): any {
        return this._locale;
    }

    // @Output() choosedDate: EventEmitter<Object>;
    // @Output() datesUpdated: EventEmitter<Object>;
    propagateChange = (_: any) => { };

    @Output('change') onChange: EventEmitter<Object> = new EventEmitter();

    constructor(
        private appService: AppService,
        private utilService: UtilService,
        private validateService: ValidationService
        //private _localeService: LocaleService
    ) {
        // this.choosedDate = new EventEmitter();
        // this.datesUpdated = new EventEmitter();
    }

    ngOnInit() {
        //this._buildLocale();
        // if(this.value == "" || this.value == undefined){
        //     this.value =  moment(moment().startOf('day')).unix().valueOf()*1000;
        //     this.propagateChange(this.value);
        // }


        // this.setStartDate(this.getMomentDate(this.value));
        this.renderTimePicker();
    }

    renderTimePicker() {
        let selected, minDate;
        if (this.minDateNumber != null && this.minDateUnit != null) {
            this.minDate = moment().subtract(this.minDateNumber, this.minDateUnit);
        }

        if (this.maxDateNumber != null && this.maxDateUnit != null) {
            this.maxDate = moment().add(this.maxDateNumber, this.maxDateUnit);
        }
        const maxDate = this.maxDate;
        minDate = this.minDate;
        selected = this.startDate.clone();
        const start = this.timePicker24Hour ? 0 : 1;
        const end = this.timePicker24Hour ? 23 : 12;
        this.timepickerVariables = {
            hours: [],
            minutes: [],
            minutesLabel: [],
            seconds: [],
            secondsLabel: [],
            disabledHours: [],
            disabledMinutes: [],
            disabledSeconds: [],
            selectedHour: 0,
            selectedMinute: 0,
            selectedSecond: 0,
        };


        // generate hours
        for (let i = start; i <= end; i++) {
            let i_in_24 = i;
            if (!this.timePicker24Hour) {
                i_in_24 = selected.hour() >= 12 ? (i === 12 ? 12 : i + 12) : (i === 12 ? 0 : i);
            }

            const time = selected.clone().hour(i_in_24);
            let disabled = false;
            if (minDate && time.minute(59).isBefore(minDate)) {
                disabled = true;
            }
            if (maxDate && time.minute(0).isAfter(maxDate)) {
                disabled = true;
            }

            this.timepickerVariables.hours.push(i);

            // for (let j = 0; j < 60; j += this.timePickerIncrement) {
            //     const time = selected.clone().minute(j);
            //     let disabled = false;
            //     if (minDate && time.second(59).isBefore(minDate)) {
            //         disabled = true;
            //     }
            //     if (maxDate && time.second(0).isAfter(maxDate)) {
            //         disabled = true;
            //     }
            //     if (i_in_24 === selected.hour() && !disabled) {
            //         this.timepickerVariables.selectedMinute = j;
            //         break;
            //     }
            // }

            if (i_in_24 === selected.hour() && !disabled) {
                this.timepickerVariables.selectedHour = i;
            } else if (disabled) {
                this.timepickerVariables.disabledHours.push(i);
            }
        }
        // generate minutes
        for (let i = 0; i < 60; i += this.timePickerIncrement) {
            const padded = i < 10 ? '0' + i : i;
            const time = selected.clone().minute(i);

            let disabled = false;
            if (minDate && time.second(59).isBefore(minDate)) {
                disabled = true;
            }
            if (maxDate && time.second(0).isAfter(maxDate)) {
                disabled = true;
            }

            this.timepickerVariables.minutes.push(i);
            this.timepickerVariables.minutesLabel.push(padded);
            if (selected.minute() === i && !disabled) {
                this.timepickerVariables.selectedMinute = i;
            } else if (disabled) {
                this.timepickerVariables.disabledMinutes.push(i);
            }
        }
        // generate seconds
        if (this.timePickerSeconds) {
            for (let i = 0; i < 60; i++) {
                const padded = i < 10 ? '0' + i : i;
                const time = selected.clone().second(i);

                let disabled = false;
                if (minDate && time.isBefore(minDate)) {
                    disabled = true;
                }
                if (maxDate && time.isAfter(maxDate)) {
                    disabled = true;
                }

                this.timepickerVariables.seconds.push(i);
                this.timepickerVariables.secondsLabel.push(padded);
                if (selected.second() === i && !disabled) {
                    this.timepickerVariables.selectedSecond = i;
                } else if (disabled) {
                    this.timepickerVariables.disabledSeconds.push(i);
                }
            }
        }
        // generate AM/PM
        if (!this.timePicker24Hour) {

            const am_html = '';
            const pm_html = '';

            if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) {
                this.timepickerVariables.amDisabled = true;
            }

            if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) {
                this.timepickerVariables.pmDisabled = true;
            }

            if (selected.hour() >= 12) {
                this.timepickerVariables.ampmModel = 'PM';
            } else {
                this.timepickerVariables.ampmModel = 'AM';
            }
        }

        this.timepickerVariables.selected = selected;
    }

    setStartDate(startDate) {
        if (typeof startDate === 'string') { // This is special case when value is string and only digit.
            var flag = /^\d+$/.test(startDate);
            if (flag)
                startDate = parseInt(startDate.trim());
        }
        if (typeof startDate === 'string') {
            this.startDate = moment(startDate, this.locale.format);
        }
        if (typeof startDate === 'number') {
            this.startDate = this.utilService.toTimeZoneDate(startDate);
        }

        if (typeof startDate === 'object') {
            this.startDate = moment(startDate);
        }
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
        }

        if (this.timePicker && this.timePickerIncrement) {
            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }

    }

    getMomentDate(unixdate: any) {
        return moment(unixdate);
    }
    timeChanged(timeEvent: any) {
        let hour = parseInt(this.timepickerVariables.selectedHour, 10);
        const minute = parseInt(this.timepickerVariables.selectedMinute, 10);
        const second = this.timePickerSeconds ? parseInt(this.timepickerVariables.selectedSecond, 10) : 0;

        if (!this.timePicker24Hour) {
            const ampm = this.timepickerVariables.ampmModel;
            if (ampm === 'PM' && hour < 12) {
                hour += 12;
            }
            if (ampm === 'AM' && hour === 12) {
                hour = 0;
            }
        }

        const start = this.startDate.clone();
        start.hour(hour);
        start.minute(minute);
        start.second(second);
        this.setStartDate(start);

        let utcDate = this.utilService.toUtcDate(this.startDate);
        this.value = utcDate.valueOf();
        this.onChange.emit(this.value);
        this.renderTimePicker();
    }

    private _buildLocale() {
        if (!this.locale.format) {
            if (this.timePicker) {
                this.locale.format = moment.localeData().longDateFormat('lll');
            } else {
                this.locale.format = moment.localeData().longDateFormat('L');
            }
        }
    }

    ngOnChanges(
        changes: {
            [propKey: string]: SimpleChange;
        }) { }

    get value() {
        return this._value;
    }

    set value(val) {
        if (val == undefined || val == '')
            val = moment(moment().startOf('day')).unix().valueOf() * 1000;
        this._value = val;
        this.setStartDate(val);
        this.renderTimePicker();
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value == '')
            value = moment(moment().startOf('day')).unix().valueOf() * 1000;
        if (value || this.value) {
            this.value = value;
            this.setStartDate(this.value);
            this.renderTimePicker();
        }

    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(fn: any): void {

    }
    setDisabledState?(isDisabled: boolean): void {
    }

    private getValue(item: any, field: any) {
        const name = field.name;
        let value = null;
        value = item[name];
        return value;
    }
    validate(value: FormControl) {
        if (this._validations) {
            return this.validateService.setValidation(value, this._validations, this.timepickerVariables);
        }
    }
}
